import React from 'react';

import { i18n } from 'config/locales';

import connectSubsection from 'components/Section/shared/SubsectionConnector';
import Subsection from 'components/Section/shared/Subsection';
import { FINANCIAL, FINANCIAL_LIEN } from 'config/formSections/financial';

import { EmptyListInstance } from 'forms/shared/models';
import Branch from 'components/Form/Branch';
import Show from 'components/Form/Show';
import Accordion from 'components/Form/Accordion';
import { Summary, DateSummary } from 'components/Summary';
import LienItem from './LienItem';

const sectionConfig = {
  key: FINANCIAL_LIEN.key,
  section: FINANCIAL.name,
  store: FINANCIAL.store,
  subsection: FINANCIAL_LIEN.name,
  storeKey: FINANCIAL_LIEN.storeKey,
};

export class Lien extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
    this.handleError = this.handleError.bind(this);
    this.summary = this.summary.bind(this);
  }

  summary = (item, index) => {
    const o = (item && item.Item) || {};
    const date = DateSummary(o.When);
    const officeName = (o.OfficeName || {}).value || '';

    return Summary({
      type: i18n.t('financial.pvq.lien.summary.type'),
      index,
      left: officeName,
      right: date,
      placeholder: i18n.t('financial.pvq.lien.summary.unknown'),
    });
  };

  update = (queue) => {
    this.props.onUpdate(this.storeKey, {
      HasLien: this.props.HasLien,
      List: this.props.List,
      ...queue,
    });
  };

  updateList = (values) => {
    this.update({
      List: values,
    });
  };

  updateHasLien = (values) => {
    this.update({
      HasLien: values,
      List: values.value === 'Yes' ? this.props.List : { items: [], branch: {} },
    });
  };

  render() {
    const {
      errors,
      required,
      scrollIntoView,
      scrollToBottom,
      defaultState,
      dispatch
    } = this.props;

    const accordionErrors = errors && errors.filter((e) => e?.indexOf?.('List.accordion') === 0);

    return (
      <div
        className="section-content lien"
        data-section={FINANCIAL.key}
        data-subsection={FINANCIAL_LIEN.key}
      >
        <h1 className="section-header">{i18n.t('financial.pvq.destination.lien')}</h1>
        <Branch
          name="has_lien"
          label={i18n.t('financial.pvq.lien.branch.title')}
          labelSize="h4"
          className="lien-branch"
          {...this.props.HasLien}
          warning
          onUpdate={this.updateHasLien}
          required={required}
          scrollIntoView={scrollIntoView}
          onError={this.handleError}
          attribute="HasLien"
        />
        <Show when={(this.props.HasLien || {}).value === 'Yes'}>
          <Accordion
            {...this.props.List}
            defaultState={defaultState}
            scrollToBottom={scrollToBottom}
            onUpdate={this.updateList}
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
            required={required}
            errors={accordionErrors}
            summary={this.summary}
            scrollIntoView={scrollIntoView}
            appendTitle={i18n.t('financial.pvq.lien.appendTitle')}
            attribute="List"
          >
            <LienItem
              name="Item"
              dispatch={dispatch}
              required={required}
              scrollIntoView={scrollIntoView}
              bind
              attribute="List"
            />
          </Accordion>
        </Show>
      </div>
    );
  }
}

Lien.defaultProps = {
  List: EmptyListInstance,
  HasAssetSeized: {},
  onUpdate: () => {},
  onError: (value, arr) => arr,
  dispatch: () => {},
  defaultState: true,
  scrollToBottom: '.bottom-btns',
  errors: [],
};

export default connectSubsection(Lien, sectionConfig);
